var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHealthcare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.418 1.17436C11.7198 0.417075 10.7617 0 9.72013 0C8.94155 0 8.22852 0.24615 7.6008 0.731554C7.28405 0.976572 6.99705 1.27634 6.74401 1.62621C6.49107 1.27644 6.20396 0.976572 5.88711 0.731554C5.25949 0.24615 4.54646 0 3.76788 0C2.72627 0 1.76812 0.417075 1.06991 1.17436C0.38003 1.92279 0 2.94525 0 4.05354C0 5.19425 0.425102 6.23843 1.33777 7.33973C2.15422 8.32484 3.32765 9.32487 4.68652 10.4829C5.15052 10.8783 5.67647 11.3266 6.22258 11.8041C6.36686 11.9304 6.55198 12 6.74401 12C6.93592 12 7.12115 11.9304 7.26522 11.8043C7.81134 11.3267 8.3376 10.8782 8.8018 10.4826C10.1605 9.32477 11.3339 8.32484 12.1503 7.33962C13.063 6.23843 13.488 5.19425 13.488 4.05344C13.488 2.94525 13.108 1.92279 12.418 1.17436Z",
    fill: "#6B6B76"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthcare);
export default __webpack_public_path__ + "static/media/healthcare.fccf37b9.svg";
export { ForwardRef as ReactComponent };